<script>
  import {
    EVENT_COLLAPSE_TOGGLE,
    EVENT_COLLAPSE_EXPANDED,
    EVENT_COLLAPSE_EXPANDING,
    EVENT_COLLAPSE_COLLAPSED,
    EVENT_COLLAPSE_COLLAPSING,
  } from '../plugins/Collapse/constants'
  import {
    ChevronDownIcon,
  } from 'vue-feather-icons'

  export default {
    name: 'FabricCollapse',
    components: {
      ChevronDownIcon,
    },
    model: {
      prop: 'modelValue',
      event: 'change'
    },
    props: {
      modelValue: Boolean,
      id: {
        type: [String, Number],
        default: (() => Math.floor(Math.random() * 100)),
      },
      title: {
        type: String,
        default: '',
      },
      defaultShown: {
        type: [Boolean, String],
        default: null,
      },
      hideHeader: {
        type: Boolean,
        default: false,
      },
      duration: {
        type: Number,
        default: 1000,
        validator: function (value) {
          // The value must match one of these Numbers
          return [1000,700,500,300,200,150,100,75].includes(value)
        }
      },
    },
    data() {
      return {
        EVENT_COLLAPSE_TOGGLE,
        EVENT_COLLAPSE_EXPANDED,
        EVENT_COLLAPSE_EXPANDING,
        EVENT_COLLAPSE_COLLAPSED,
        EVENT_COLLAPSE_COLLAPSING,
        expanded: false,
        expanding: false,
        collapsed: true,
        collapsing: false,
        durationClass: '',
        shown: Boolean(this.modelValue), /* Init from model-value don't bind */
      }
    },
    computed: {
      whitelistStyle() {
        return {
          duration: 'tw-duration-75 tw-duration-100 tw-duration-150 tw-duration-200 tw-duration-300 tw-duration-500 tw-duration-700 tw-duration-1000',
        }
      },
      isShown(){
        return this.expanded || this.expanding
      },
      computedId(){
        return `${this.id}__fb_collapse__`
      }
    },
    watch: {
      // when the computed display value changes update our data binding
      isShown(newValue, oldValue){
        this.shown = newValue
      },
      // when our data binding updates (for any reason), update the v-model
      shown(newValue, oldValue){
        this.$emit('change', newValue)
      },
      modelValue(newValue, oldValue){
        if (newValue !== this.shown){
          if (newValue){
            this.expanded = true;
            this.collapsed = false;
          }else{
            this.expanded = false;
            this.collapsed = true;
          }
        }
      }
    },
    created(){
      this.durationClass = `tw-duration-${this.duration}`

      // init flow based on forced
      if (this.defaultShown !== null){
        // have a forced direction,
        if (this.defaultShown){
          this.expanded = true;
          this.collapsed = false;
        }else{
          this.expanded = false;
          this.collapsed = true;
        }
      }else{
        // align from default show.
        if (this.modelValue){
          this.expanded = true;
          this.collapsed = false;
        }else{
          this.expanded = false;
          this.collapsed = true;
        }
      }
    },
    mounted() {
      this.$root.$on(EVENT_COLLAPSE_TOGGLE, dataEvent => {
        const { id } = dataEvent
        if (id === this.computedId) {
          this.toggleVisibility()
        }
      })
    },
    methods: {
      toggleVisibility(){
        if(this.expanding || this.collapsing){
          return
        }
        if(this.isShown){
          this.onHide()
        }else{
          this.onShow()
        }
      },
      onShow() {
        this.$emit('expanding', this.id)
        this.collapsed = false
        this.expanded = false
        this.expanding = true

        setTimeout(() => {
          this.expanded = true
          this.expanding = false
          this.$emit('expanded', this.id)
        }, this.duration)
      },
      onHide() {
        this.$emit('collapsing', this.id)
        this.collapsed = false
        this.expanded = false
        this.collapsing = true

        setTimeout(() => {
          this.collapsed = true
          this.collapsing = false
          this.$emit('collapsed', this.id)
        }, this.duration)
      },
    },
  }
</script>

<template>
  <section
    :id="id + '__fb_collapse__'"
    class="tw-flex tw-flex-col tw-w-full">
    <div
      v-if="!hideHeader"
      class="tw-inline-flex tw-flex-row">
      <article>
        {{title}}
      </article>
      <transition
        name="rotate"
        enter-class="rotate-enter"
        leave-to-class="rotate-leave-to"
        :enter-active-class="'tw-ease-in-out ' + durationClass"
        :leave-active-class="'tw-ease-in-out ' + durationClass"
        css>
        <ChevronDownIcon
          v-show="isShown"
          class="!tw-block"
          :class="{
            'rotate-collapsed': collapsed,
            'rotate-expanded': expanded,
          }"
          @click="toggleVisibility"/>
      </transition>
    </div>
    <FabricTransitionHeight
      :duration="duration">
      <div v-show="isShown">
        <slot />
      </div>
    </FabricTransitionHeight>
  </section>
</template>

<style scoped>
  .rotate-enter, .rotate-leave-to, .rotate-collapsed{
    transform: rotate(180deg);
  }

  .rotate-enter-to, .rotate-leave, .rotate-expanded {
    transform: rotate(0deg);
  }
</style>
